import React, { useState } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import Featur_1 from '../../../assets/images/featured-product/01.png';
import Featur_2 from '../../../assets/images/featured-product/02.png';
import Featur_3 from '../../../assets/images/featured-product/03.png';

const products = {
    Furniture: [
        {
            id: 1,
            image: Featur_1,
            title: 'Mini Chair Still Stands',
            price: '$80.00',
            rating: 4.8,
            reviews: 1248,
            badge: 'New',
        },
        {
            id: 2,
            image: Featur_2,
            title: 'Wooden Chair mini',
            price: '$120.00',
            rating: 4.8,
            reviews: 850,
        },
        {
            id: 3,
            image: Featur_3,
            title: 'Jamping Chair Premium',
            price: '$260.00',
            rating: 4.8,
            reviews: 1248,
        },
    ],
    Lightings: [
        {
            id: 4,
            image: Featur_1,
            title: 'Mini Chair Still Stands',
            price: '$80.00',
            rating: 4.8,
            reviews: 1248,
            badge: 'New',
        },
        {
            id: 5,
            image: Featur_2,
            title: 'Wooden Chair mini',
            price: '$120.00',
            rating: 4.8,
            reviews: 850,
        },
        {
            id: 6,
            image: Featur_3,
            title: 'Jamping Chair Premium',
            price: '$260.00',
            rating: 4.8,
            reviews: 1248,
        },
    ],
    Decors: [
        {
            id: 7,
            image: Featur_1,
            title: 'Mini Chair Still Stands',
            price: '$80.00',
            rating: 4.8,
            reviews: 1248,
            badge: 'New',
        },
        {
            id: 8,
            image: Featur_2,
            title: 'Wooden Chair mini',
            price: '$120.00',
            rating: 4.8,
            reviews: 850,
        },
        {
            id: 9,
            image: Featur_3,
            title: 'Jamping Chair Premium',
            price: '$260.00',
            rating: 4.8,
            reviews: 1248,
        },
    ],
    Textiles: [
        {
            id: 10,
            image: Featur_1,
            title: 'Mini Chair Still Stands',
            price: '$80.00',
            rating: 4.8,
            reviews: 1248,
            badge: 'New',
        },
        {
            id: 11,
            image: Featur_2,
            title: 'Wooden Chair mini',
            price: '$120.00',
            rating: 4.8,
            reviews: 850,
        },
        {
            id: 12,
            image: Featur_3,
            title: 'Jamping Chair Premium',
            price: '$260.00',
            rating: 4.8,
            reviews: 1248,
        },
    ],
};

const featurSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 740,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            },
        },
    ],
};

const Featur = () => {
    const [category, setCategory] = useState("Furniture");

    const handleTabChange = (tab) => {
        setCategory(tab);
    };

    return (
        <section id="featured-product" className="featured-product-main-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="section">
                            <h2 className="section-heading-four">Featured Products</h2>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-6">
                        <ul
                            className="featured-product-nav-pills nav nav-pills float-end"
                            id="pills-tab"
                            role="tablist"
                        >
                            {Object.keys(products).map((key) => (
                                <li className="nav-item" role="presentation" key={key}>
                                    <Link
                                        className={`nav-link ${category === key ? "active" : ""}`}
                                        onClick={() => handleTabChange(key)}
                                        id={`pills-tab${key}-tab`}
                                        data-bs-toggle="pill"
                                        data-bs-target={`#pills-tab${key}`}
                                        title=""
                                        role="tab"
                                        aria-controls={`pills-tab${key}`}
                                        aria-selected={category === key}
                                    >
                                        {key}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="tab-content" id="pills-tabContent">
                        {Object.keys(products).map((key) => (
                            <div
                                key={key}
                                className={`tab-pane fade ${category === key ? 'show active' : ''}`}
                                id={`pills-tab${key}`}
                                role="tabpanel"
                                aria-labelledby={`pills-tab${key}-tab`}
                            >
                                <Slider className="slider featured-autoplay-slider" {...featurSettings}>
                                    {products[key].map(product => (
                                        <div key={product.id} className="featured-product-block">
                                            <div className="featured-product-img">
                                                {product.badge && <span className="badge badge-four">{product.badge}</span>}
                                                <Link to="/Shopdetails" className="sale" title="">
                                                    <img
                                                        src={product.image}
                                                        className="img-fluid"
                                                        alt={product.title}
                                                    />
                                                </Link>
                                                <Link to="#" className="btn btn-secondary-four" title="">
                                                    Add To Cart
                                                </Link>
                                            </div>
                                            <div className="featured-product-dtls">
                                                <div className="trending-product-dtls">
                                                    <div className="row">
                                                        <div className="col-lg-8 col-8">
                                                            <h5 className="trending-product-title">
                                                                <Link to="/Shopdetails" title="">
                                                                    {product.title}
                                                                </Link>
                                                            </h5>
                                                            <p className="rate">{product.price}</p>
                                                        </div>
                                                        <div className="col-lg-4 col-4">
                                                            <div className="trending-product-rating">
                                                                <span className="badge badge-two">
                                                                    {product.rating}
                                                                    <i className="flaticon-star" />
                                                                </span>
                                                                <p className="review">({product.reviews})</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Featur;